/** Determines on which part of the façade hierarchy the space should be placed
 * `Primary`: main façade in terms of access and aesthetics
 * `Secondary`: still important in terms of aesthetics, but probably not as visible as `Primary`
 * `Tertiary`: least important portion of the façade in terms of access and aesthetics. Usually used to accomodate service spaces.
*/
var SpaceFacadeLocation;
(function (SpaceFacadeLocation) {
    SpaceFacadeLocation["Primary"] = "Primary";
    SpaceFacadeLocation["Secondary"] = "Secondary";
    SpaceFacadeLocation["Tertiary"] = "Tertiary";
})(SpaceFacadeLocation || (SpaceFacadeLocation = {}));

export { SpaceFacadeLocation };
//# sourceMappingURL=space-facade-location.js.map
